import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './style.css';
import "@fontsource/source-sans-pro";
import "@fontsource/source-sans-pro/300.css";
import "@fontsource/source-sans-pro/400.css";
import "@fontsource/source-sans-pro/600.css";
import "@fontsource/source-sans-pro/700.css";
import { TokenProvider } from './utils/TokenContext';
import PageNotFoundPage from './components/PageNotFound/PageNotFound';
import LoginPage from './components/Login/Login';
import TicketListsPage from './components/Ticket/TicketLists';
import HierarchyManagementPage from './components/HierarchyManagement/HierarchyManagement';
import { ToastContainer } from 'react-toastify';
import PrivateRoute from './utils/routes/PrivateRoute';
import PublicRoute from './utils/routes/PublicRoute';
import Dashboard from './components/Ticket/Dashboard';
import SLADurations from './components/HierarchyManagement/SLADurations';
 
const App = () => {
  return (
      <Router>
        <Routes>
 
 
          <Route path="/" element={<PublicRoute element={<LoginPage />} />} />
 
          <Route path="/ticket-lists" element={<PrivateRoute element={<TicketListsPage />} />} />
          <Route path="/hierarchy" element={<PrivateRoute element={<HierarchyManagementPage />} />} />
          <Route path="/insights" element={<PrivateRoute element={<Dashboard />} />} />
          <Route path="/sla-durations" element={<PrivateRoute element={<SLADurations />} />} />
          <Route path="*" element={<PageNotFoundPage />} />
        </Routes>
        <ToastContainer />
      </Router>
  );
};
 
export default App;